import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["input", "select"];

  connect() {
    this.inputTarget.addEventListener("input", this.autocomplete.bind(this));
  }

  autocomplete() {
    const inputValue = this.inputTarget.value.toLowerCase();
    const solution = this.data.get("solution");
    const action = this.data.get("action");
    const controller = this.data.get("controlleur");
    const other_params = this.data.get("other_params");
    fetch(`/${solution}/${controller}/${action}?query=${inputValue}&${other_params}`)
      .then((response) => response.json())
      .then((data) => {
        this.updateSelectList(data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  updateSelectList(options) {
    const select = this.selectTarget;
    select.innerHTML = ""; // Clear previous options

    options.forEach((option) => {
      const optionElement = document.createElement("option");
      optionElement.value = option.value;
      optionElement.textContent = option.label;
      select.appendChild(optionElement);
    });
  }
}
